import { Model } from "pinia-orm";
import { Session, UserSessionsGroup } from "@/models";
import dayjs from "dayjs";
import { SESSIONS_GROUP_TYPE } from "@/models/enums/sessionsGroup";

export default class SessionsGroup extends Model {
  static entity = "sessionsGroups";
  static primaryKey = "uuid";

  static pendingStatuses = [SESSIONS_GROUP_TYPE.COMING];
  static nowStatuses = [SESSIONS_GROUP_TYPE.TODAY];
  static pastStatuses = [SESSIONS_GROUP_TYPE.DONE];

  static fields() {
    return {
      uuid: this.uid(""),
      createdAt: this.string(""),
      name: this.string(""),
      isDisplayed: this.boolean(true),
      remote: this.boolean(false),
      date: this.string(""),
      location: this.string(""),
      seats: this.number(null),
      privateSession: this.boolean(true),
      status: this.string(""),
      toCorrect: this.boolean(null),
      nbCandidatesRegistred: this.number(null),
      allConvocationsSent: this.boolean(null),
      isCancelled: this.boolean(false),
      // Foreign keys
      sessions: this.hasMany(Session, "sessionsGroupUuid"),
      domains: this.attr([]),
      userSessionsGroups: this.hasMany(UserSessionsGroup, "sessionsGroupUuid"),
    };
  }

  get getStatus() {
    const date = dayjs(this.date);
    const today = dayjs().startOf("day");
    if (this.isCancelled) {
      return SESSIONS_GROUP_TYPE.CANCELLED;
    } else if (date.isAfter(today)) {
      return SESSIONS_GROUP_TYPE.COMING;
    } else if (date.isSame(today)) {
      return SESSIONS_GROUP_TYPE.TODAY;
    } else if (date.isBefore(today)) {
      return SESSIONS_GROUP_TYPE.DONE;
    }
    return null;
  }
}
